<template>
  <div>
    <v-data-table
      :headers="qAHeaders"
      :items="filteredItems"
      style="border: solid 1px;"
      :sort-by="sortBy"
      :footer-props="pagination"
    >
      <template v-slot:top>
        <div class="pa-3">
          <v-row dense>
            <v-col class="py-0">
              <v-autocomplete
                variant="underlined"
                :items="removeDuplicateFilters"
                item-title="parentQuestion.label"
                item-value="parentQuestion.label"
                label="Search"
                hide-no-data
                v-model="parentSearch"
                hide-selected
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="parentSearch && extraItemsForFiltering.length" class="py-0">
              <v-autocomplete
                variant="underlined"
                :items="extraItemsForFiltering"
                item-title="fullLabel"
                item-value="fullLabel"
                label="Filter"
                v-model="innerParentSearch"
                hide-no-data
                hide-selected
                clearable
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>

        <v-row justify="end" dense>
          <v-col cols="12" sm="3" class="py-0 mr-3" style="display: flex; justify-content: flex-end">
            <v-menu top close-on-click>
              <template v-slot:activator="{ props }">
              <v-btn color="primary" class="white-text" small v-bind="props">
                Bulk Options <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>

              <v-list>
                <v-list-item @click="showCloneDialog = true">
                  <v-list-item-title>Clone</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="props">
        <tr>
          <td>
            <a @click="editQuestion(props.item.parentQuestion)" class="blue-link">{{ props.item.parentQuestion.label }}</a>
          </td>
          <td>
            <a
              v-if="answerTypesMap[props.item.parentQuestion.type].dependants"
              @click="editAnswerQuestions(props.item)"
              class="blue-link"
            >
              {{ props.item.label }}
            </a>
            <span v-if="!answerTypesMap[props.item.parentQuestion.type].dependants">
              {{ props.item.label }}
            </span>
          </td>
          <td>
            <div v-if="props.item.parentQuestion">
              <div v-for="(q, i) in props.item.parentQuestion.questionHierarchy" :key="i">
                {{ q.label }} {{ i === props.item.parentQuestion.questionHierarchy.length - 1 ? '' : '/' }}
              </div>
            </div>
          </td>
          <td>
            <div v-if="props.item.parentQuestion">
              <div v-for="(v, i) in props.item.parentQuestion.answerHierarchy" :key="i">
                {{ v.label }} {{ i === props.item.parentQuestion.answerHierarchy.length - 1 ? '' : '/' }}
              </div>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog persistent v-model="showCloneDialog" max-width="900">
      <CloneQA v-if="showCloneDialog" :allQA="qa" @clone="clone" @close="showCloneDialog = false" />
    </v-dialog>
  </div>
</template>
<script>
import { AnswerTypes } from '@/common/types'
import CloneQA from './CloneQA'

export default {
  name: 'QATable',
  components: {
    CloneQA
  },
  props: {
    qa: Array,
    relationships: Array
  },
  data() {
    return {
      qAHeaders: [
        {
          title: 'Field',
          key: 'parentQuestion.label'
        },
        {
          title: 'Response',
          sortable: false
        },
        {
          title: 'Field Hierarchy',
          sortable: false
        },
        {
          title: 'Response Hierarchy',
          sortable: false
        }
      ],
      parentSearch: '',
      innerParentSearch: '',
      answerTypesMap: AnswerTypes.properties,
      selected: [],
      sortDesc: [false],
      sortBy: [{ key: 'parentQuestion.label', order: 'asc' }],
      showCloneDialog: false,
      pagination: {
        'items-per-page-options': [10, 20, 30, 40]
      }
    }
  },
  computed: {
    availableForSelection() {
      const sort = this.sortDesc.map(s => (s ? 'desc' : 'asc'))
      return this.$_.orderBy(
        this.filteredItems.filter(i => AnswerTypes.properties[i.parentQuestion.type].dependants),
        this.sortBy,
        sort
      )
    },
    extraItemsForFiltering() {
      const arr = this.availableForSelection
        .filter(q => (q.parentQuestion.questionHierarchy || []).length)
        .map(item => {
          return { ...item.parentQuestion }
        })
      return Array.from(new Map(arr.map(obj => [obj.id, obj])).values())
    },
    filteredItems() {
      if (this.parentSearch && this.innerParentSearch) {
        return this.qa.filter(q => {
          return q.parentQuestion.fullLabel.toLowerCase() === this.innerParentSearch.toLowerCase()
        })
      } else if (this.parentSearch) {
        return this.qa.filter(q => {
          return q.parentQuestion.label.toLowerCase() === this.parentSearch.toLowerCase()
        })
      }

      return this.qa
    },
    removeDuplicateFilters () {
      const newQA = [];
      this.qa.forEach(q => {
        if (!newQA.some(n => n.parentQuestion.label === q.parentQuestion.label)) {
          newQA.push(q)
        }
      })
      return newQA
    }
  },
  methods: {
    editAnswerQuestions(item) {
      this.$emit('editAnswerQuestions', item)
    },
    editQuestion(item) {
      this.$emit('editQuestion', item)
    },
    clone(selectedField, answerTarget, includeChildren) {
      this.showCloneDialog = false
      this.selected = []
      this.parentSearch = ''
      this.$emit('clone', selectedField, answerTarget, includeChildren)
    }
  },
  watch: {
    parentSearch(newValue, oldValue) {
      this.innerParentSearch = ''
    }
  }
}
</script>
